import { Box, Button, Grid, Typography } from "@mui/material";
import Modal from "components/Modal";
import NumberFormats from "components/NumberFormats";
import React from "react";
import WrapperStepper from "../../../../WrapperStepper";

export default function ReleaseModal({ onClose, open }) {
  const steps = [
    {
      label: "شروع قرارداد",
      description: `2023/04/06   16:43`,
    },

    {
      label: "پایان قرارداد",
      description: `2023/05/08   13:00`,
    },
  ];
  return (
    <Modal
      maxWidth={"sm"}
      onClose={onClose}
      open={open}
      title="release"
      dir="ltr"
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h5" lineHeight={2} textAlign="right" dir="rtl">
            شما در حال لغو قرارداد زودتر از موعد هستید. با بستن قرارداد هیچ سودی
            به شما تعلق نخواهد گرفت.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box py={2}>
            <Typography variant="h4" color="text.secondary" pb={1}>
              Amount
            </Typography>
            <Typography variant="h5">
              <NumberFormats value={40000} /> USDT
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} mb={2}>
          <Typography variant="h4" pb={2}>
            {" "}
            Summary
          </Typography>

          <WrapperStepper steps={steps} />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6} md={6}>
              <Button color="info" fullWidth onClick={onClose}>
                Back
              </Button>
            </Grid>

            <Grid item xs={6} md={6}>
              <Button color="success" fullWidth onClick={onClose}>
                Confirm
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
